import {
    Card,
    Display,
    List
} from "stentor-models";
import { TableDisplayData } from "../components/Table";

/**
 * Is the Display a Card
 *
 * @privateRemarks We don't want to include stentor-response as a dependency so we are redefining them.
 * @param display
 * @returns
 */
export function isCard(display: Display): display is Card {
    return !!display && (display as Card).type === "CARD";
}

/**
 * Is the Display a List
 *
 * @privateRemarks We don't want to include stentor-response as a dependency so we are redefining them.
 * @param display
 * @returns
 */
export function isList(display: Display): display is List {
    return !!display && ((display as List).type === "LIST" || (display as List).type === "CAROUSEL");
}

/**
 * Is the Display a Table
 */
export function isTable(display: Display): display is TableDisplayData {
    return !!display && (display as TableDisplayData).type === "TABLE"
        && Array.isArray((display as TableDisplayData).headers)
        && Array.isArray((display as TableDisplayData).rows);
}